module.exports = __webpack_public_path__ + "img/banner-small.e01ad594.jpg";